const urls = {
    // AUTH
    Login: process.env.VUE_APP_MEMBER_API_URL + 'member/v4/otpLogin', // 登入
    CheckOtpLogin: process.env.VUE_APP_MEMBER_API_URL + 'member/v4/checkOtpLogin', // 登入 OTP 驗證
    Register: process.env.VUE_APP_MEMBER_API_URL + 'member/v4/otpRegister', // 註冊
    CheckOtpRegister: process.env.VUE_APP_MEMBER_API_URL + 'member/v4/checkOtpRegister', // 註冊 OTP 驗證
    RefreshToken: process.env.VUE_APP_MEMBER_API_URL + 'member/v4/refreshToken', // Token Refresh
    RefreshToken4WT: process.env.VUE_APP_MEMBER_API_URL + 'member/v2/refreshToken4WT', // Token Refresh
    Userapi: process.env.VUE_APP_MEMBER_API_URL + 'userapi/v1/get', // 取得用戶資料
    Logout: process.env.VUE_APP_MEMBER_API_URL + 'member/v4/logout', // 取得用戶資料
    UpdateMemberTerms: process.env.VUE_APP_MEMBER_API_URL + 'userapi/v1/updateMemberTerms', // 更新會員條款
    GetBirthdayCheck: process.env.VUE_APP_MEMBER_API_URL + 'userapi/v1/getBirthdayCheck',// 取得用戶生日確認 (僅供經過認證的用戶取得自己的資料)

    // CMS
    MostPopularCombination: process.env.VUE_APP_CMS_API_URL + 'MostPopularCombination', // 最熱門車險組合
    InsCombination: process.env.VUE_APP_CMS_API_URL + 'InsCombination', // 商品組合
    YouNeedKnow: process.env.VUE_APP_CMS_API_URL + 'YouNeedKnow', // 您需要知道的事
    School: process.env.VUE_APP_CMS_API_URL + 'School', // 保險小學堂
    QuestionsCategory: process.env.VUE_APP_CMS_API_URL + 'QuestionsCategory', // Q&A Tab
    Questions: process.env.VUE_APP_CMS_API_URL + 'Questions', // Q&A
    Insures: process.env.VUE_APP_CMS_API_URL + 'Insures', // 險種介紹 i
    InsuresName: process.env.VUE_APP_CMS_API_URL + 'InsuresName', // 險種名稱
    Terms: process.env.VUE_APP_CMS_API_URL + 'Terms', // 聲明事項文案＆時間
    Marquees: process.env.VUE_APP_CMS_API_URL + 'Marquees', // 跑馬燈
    InsKnowledge: process.env.VUE_APP_CMS_API_URL + 'InsKnowledge', // 認識保險商品
    SharePost: process.env.VUE_APP_CMS_API_URL + 'SharePost', // 分享表單 - 傳送
    ShareGet: process.env.VUE_APP_CMS_API_URL + 'ShareGet', // 分享表單 - 接收
    Advertise: process.env.VUE_APP_CMS_API_URL + 'Advertise', // 廣告版位    
    Maintain: process.env.VUE_APP_CMS_API_URL + 'Maintain', // 停機維護公告

    //Car
    GetBrandGroup: process.env.VUE_APP_TMNEWA_API_URL + 'Car/GetBrandGroup', // 取得廠牌
    GetBrandList: process.env.VUE_APP_TMNEWA_API_URL + 'Car/GetBrandList', // 取得廠牌(機車)
    GetCarStyles: process.env.VUE_APP_TMNEWA_API_URL + 'Car/GetCarStyles', // 取得車系
    GetCarModels: process.env.VUE_APP_TMNEWA_API_URL + 'Car/GetCarModels', // 取得車款
    SimpleCalculate: process.env.VUE_APP_TMNEWA_API_URL + 'Car/SimpleCalculate', // 快速、未登入試算
    Calculate: process.env.VUE_APP_TMNEWA_API_URL + 'Car/Calculate', // 車險試算
    GetInsuresAndCovers: process.env.VUE_APP_TMNEWA_API_URL + 'Car/GetInsuresAndCovers', // 商品清單取得
    GetValidInsAndCovers: process.env.VUE_APP_TMNEWA_API_URL + 'Car/GetValidInsAndCovers', // 商品清單取得(依據estimate)
    InitPolicy: process.env.VUE_APP_TMNEWA_API_URL + 'Car/InitPolicy', // 高風險身份檢核+活動代碼驗證
    CheckBeforeSave: process.env.VUE_APP_TMNEWA_API_URL + 'Car/CheckBeforeSave', // 存檔前檢核
    SavePolicy: process.env.VUE_APP_TMNEWA_API_URL + 'Car/SavePolicy', // 車險同意要保(新/續保共用)
    ECToEB: process.env.VUE_APP_TMNEWA_API_URL +  'Car/ECToEB', // 網投轉網要
    SendConfirmMail: process.env.VUE_APP_TMNEWA_API_URL + 'Car/SendConfirmMail', // 客戶要保確認通知
    UpdateApplicantPostStatus: process.env.VUE_APP_TMNEWA_API_URL + 'Car/UpdateApplicantPostStatus', // 更新要保書列印狀態
    PolicyProgress: process.env.VUE_APP_TMNEWA_API_URL +  'Car/PolicyProgress', // 投保後查詢
    Contact: process.env.VUE_APP_TMNEWA_API_URL + 'Car/Contact', // 紀錄要聯絡客戶
    GetProposal: process.env.VUE_APP_TMNEWA_API_URL + 'Car/GetProposal', // 取得要保書
    RenewLogin: process.env.VUE_APP_TMNEWA_API_URL + 'Car/RenewLogin', // 續保登入
    GetAccuDK: process.env.VUE_APP_TMNEWA_API_URL + 'Car/GetAccuDK', // Yahoo Ebo行銷引導
    OrderMail: process.env.VUE_APP_TMNEWA_API_URL + 'Car/OrderMail', // 試算單功能
    ApplicantLogin: process.env.VUE_APP_TMNEWA_API_URL + 'Car/ApplicantLogin', // 試算單登入
    GetMIDUrl: process.env.VUE_APP_TMNEWA_API_URL + 'Car/GetMIDUrl', // 取得MID驗證網址
    GetMIDProposal: process.env.VUE_APP_TMNEWA_API_URL + 'Car/GetMIDProposal', // 取得線上預覽要保書
    UpdateMIDStatus: process.env.VUE_APP_TMNEWA_API_URL + 'Car/UpdateMIDStatus', // 更新MID驗證狀態

    //Common
    GetRiskCountryList: process.env.VUE_APP_TMNEWA_API_URL + 'Common/GetRiskCountryList', // 取得風險國家清單
    GetOccupList: process.env.VUE_APP_TMNEWA_API_URL + 'Common/GetOccupList', // 取得職業清單
    GetZipData: process.env.VUE_APP_TMNEWA_API_URL + 'Common/GetZipData', // 取得郵遞區號清單
    GetBankCodes: process.env.VUE_APP_TMNEWA_API_URL + 'Common/GetBankCodes', // 取得銀行代碼清單
    VerificationCode: process.env.VUE_APP_TMNEWA_API_URL + 'Common/VerificationCode', // 圖文驗證碼
    ForgetPw: process.env.VUE_APP_TMNEWA_API_URL + 'Common/ForgetPw', // 查詢續保密碼
    SearchCustomer: process.env.VUE_APP_TMNEWA_API_URL + 'Common/SearchCustomer', // 檢查是否已註冊會員    
    SendClientError: process.env.VUE_APP_TMNEWA_API_URL + 'Common/SendClientError', // 寄送客戶端錯誤通知信
    UpdateMember: process.env.VUE_APP_TMNEWA_API_URL + 'Common/UpdateMember', // 更新會員資料:生日
    PartnerExchange: process.env.VUE_APP_TMNEWA_API_URL + 'Common/PartnerExchange', // 跟玉山取得顧客資料
    
    // Payment
    CarPayment: process.env.VUE_APP_TMNEWA_API_URL + 'Payment/CarPayment', // 車險網投/網要進行結帳
    CardLinkCommunicationVerify: process.env.VUE_APP_TMNEWA_API_URL + 'Payment/CardLinkCommunicationVerify', // 跟玉山取得交易Token

    // Finish
    GetCarPolicyByTradeData: process.env.VUE_APP_TMNEWA_API_URL + 'Payment/GetCarPolicyByTradeData', // 取得第三方支付繳費完 跳轉回完成頁所需資料

    //File
    Upload: process.env.VUE_APP_TMNEWA_API_URL + 'File/Upload', // 上傳檔案
    Download: process.env.VUE_APP_TMNEWA_API_URL + 'File/Download', // 檔案下載

    //Log
    ClarityLog: process.env.VUE_APP_LOG_API_URL + 'clarity/v1/event', //Clarity Log

    // ONLY TEST
    LogWrite: process.env.VUE_APP_CMS_API_URL + 'LogWrite' // 寫入 LOG
};

export default urls;